// components/CommonBarChart.tsx
import React from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid, ResponsiveContainer } from "recharts";

type ChartData = {
  [key: string]: string | number;
};

interface BarChartProps {
  data: ChartData[];
  xKey?: string;
  barKeys?: string[];
  colors?: string[];
  Header: string;
}

const CommonBarChart: React.FC<BarChartProps> = ({ data, xKey = "name", barKeys = ["sales", "purchases"], colors = ["#2980b9", "#ffc658", "#82ca9d"], Header }) => {
  return (
    <div className="flex flex-col w-full max-w-4xl h-fit items-start justify-center p-4 bg-white dark:bg-slate-400 rounded-lg shadow-md">
      <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-4">{Header}</h2>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={xKey} />
          <YAxis />
          <Tooltip />
          <Legend />
          {barKeys.map((key, index) => (
            <Bar key={key} dataKey={key} fill={colors[index % colors.length]} />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CommonBarChart;
